import request from 'assets/js/http';

// 项目-vote管理详情，新建 and 编辑
/**
 * projectId: 3//项目id
 * voteId: 12//新建为空
 */
export function voteMangeInfo(data) {
  return request({
    url: '/projectVote/voteManageInfo',
    method: 'post',
    data
  });
}

//新建vote获取关联会议列表
export function voteMeetingList(data) {
  return request({
    url: '/meetingProject/meeting',
    method: 'post',
    data
  });
}

// 项目-vote，发起vote
/**
 * projectId: 1,
 * selectedRound: "A轮",
 * selectedDecisionPoint: "pre ts",
 * invitedPeople: 1, 2, 3, 4
 * voteMode: 1,
 * voteName: "投票名称"
 * voteIllustrate: "投票附加说明信息"
 */
export function askVote(data) {
  return request({
    url: '/projectVote/manage',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}

// 项目-vote，关闭vote
/**
 * voteId: 1
 * type: 1//1-关闭，2-开启，3-删除
 */
export function manageVoteStatus(data) {
  return request({
    url: '/projectVote/manageStatus',
    method: 'post',
    data
  });
}
// 项目-vote，vote详情
/**
 * voteId: 1
 */
export function voteDetail(data) {
  return request({
    url: '/projectVote/getVoteDetail',
    method: 'post',
    data
  });
}

// 项目-vote，提交record
/**
voteId:1,
substituteId: 13,//被代替者，如果是本人填写为空
voteContent: 0, //0~4还是如何？
voteReason: "市场规模足够，技术优势明显",
additionalPoint: "该赛道更适合天使轮",
voteRecordId: 4,
 */
export function vote(data) {
  return request({
    url: '/projectVote/submitVoteRecord',
    method: 'post',
    data
  });
}

// 项目-vote，删除某个投票记录
/**
 * voteRecordId: 1
 */
export function deleteVoteRecord(data) {
  return request({
    url: '/projectVote/deleteVoteRecord',
    method: 'post',
    data
  });
}
